import { createResource } from 'redux-rest-resource';
import { HEADERS as headers, INTEGRATORS_URL } from '../../Constants';
import { transformFetchResponse as transformResponse } from '../../Helpers';

export const { types, actions, reducers } = createResource({
  name: 'allIntegrator',
  url: `${INTEGRATORS_URL}/all`,
  headers,
  actions: {
    fetch: {
      transformResponse,
    },
  },
});
